import { Card, CardContent } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import ConsentForm from '@views/ManageAccount/Consent/ConsentForm';
import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';

const messages = defineMessages({
  title: {
    id: 'manageAccount.consents',
    defaultMessage: 'Consents',
  },
});

export default function ManageAccountPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user_id }) => (
        <Card>
          <CardContent>
            <ConsentForm user_id={user_id} vitall_toc_poc_consent />
          </CardContent>
        </Card>
      )}
    </ManageAccountLayout>
  );
}
